import { Box } from "@mui/material";
import type { Workflow } from "../../../../../api/types/workflowTypes";
import CitationsPreview from "./CitationsPreview";
import { getMainChangeSet, type FilePreviewState } from "./workflowDetailsHelpers";
import WorkflowDocumentPreview from "./WorkflowDocumentPreview";
import WorkflowEmailPreviewContent from "./WorkflowEmailPreviewContent";
import WorkflowFilePreviewHeader from "./WorkflowFilePreviewHeader";

interface Props {
  filePreview: FilePreviewState;
  workflow: Workflow;
  onClose: () => void;
}

const WorkflowFilePreview = ({ filePreview, workflow, onClose }: Props) => {
  if (filePreview.type === "email") {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
        <WorkflowFilePreviewHeader title={filePreview.subject || "Email"} isEmail onClose={onClose} />
        <WorkflowEmailPreviewContent workflowId={workflow.id} />
      </Box>
    );
  }

  const activity =
    filePreview.type === "document"
      ? workflow.activities.find((a) => a.type === "ExtractFieldsFromDocument")
      : workflow.activities.find((a) => a.workflowActivityId === filePreview.activityId);

  const documentName = filePreview.type === "document" ? filePreview.attachment.fileName : filePreview.documentName;
  const fileCatalogId = filePreview.type === "document" ? filePreview.attachment.fileCatalogId : undefined;
  const changeSet = activity ? getMainChangeSet(activity) : undefined;
  const previewCitations = changeSet?.citations?.filter((c) => c.documentName === documentName) ?? [];
  const activityId = activity?.workflowActivityId;
  const { selectedCitationId } = filePreview;

  if (previewCitations.length === 0 && fileCatalogId) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
        <WorkflowDocumentPreview
          fileName={documentName}
          fileCatalogId={fileCatalogId}
          workflowId={workflow.id}
          onClose={onClose}
        />
      </Box>
    );
  }

  if (previewCitations.length > 0 && activityId) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
        <CitationsPreview
          workflowId={workflow.id}
          activityId={activityId}
          documentName={documentName}
          citations={previewCitations}
          selectedCitationId={selectedCitationId}
          onClose={onClose}
        />
      </Box>
    );
  }

  return null;
};

export default WorkflowFilePreview;
